import { SVGProps } from "react";

const SortDescIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.484745 5.54194H9.21202C9.3079 5.54192 9.40162 5.5134 9.48133 5.45998C9.56105 5.40657 9.62318 5.33066 9.65986 5.24184C9.69655 5.15303 9.70615 5.05531 9.68745 4.96102C9.66876 4.86674 9.62259 4.78013 9.55481 4.71215L5.19117 0.33715C5.14617 0.291991 5.09273 0.256167 5.03392 0.231725C4.9751 0.207283 4.91205 0.194702 4.84838 0.194702C4.78471 0.194702 4.72167 0.207283 4.66285 0.231725C4.60403 0.256167 4.5506 0.291991 4.5056 0.33715L0.141958 4.71215C0.0741711 4.78013 0.0280102 4.86674 0.00931075 4.96102C-0.00938867 5.05531 0.000212908 5.15303 0.0369014 5.24184C0.0735899 5.33066 0.135718 5.40657 0.215432 5.45998C0.295146 5.5134 0.388866 5.54192 0.484745 5.54194Z"
        fill="#04152D"
      />
    </svg>
  );
};

export default SortDescIcon;
